const localAssistantAppStore = {
  async openFolder(folderPath, jobComponentId, userId) {
    let success = false;

    try {
      const response = await fetch('http://localhost:56065/open-folder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          subfolder_location: folderPath
        })
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Folder opened successfully');
        success = true;
      } else {
        if (data.message.includes("Folder does not exist")) {
          AF.UI.notify.error('Unable to open folder: Folder not accessible.')
        }

        console.error('Failed to open folder:', data.message);
      }
    } catch (error) {
      console.error('Error opening folder:', error);
    }

    this.logOpenFolder(jobComponentId, userId, success);
  },

  async logOpenFolder(jobComponentId, userId, success) {
    try {
      await fetch('/api/local-assistant/log-open-folder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          job_component_id: jobComponentId,
          user_id: userId,
          success: success
        })
      });
    } catch (error) {
      console.error('Error logging open folder action:', error);
    }
  }
};

function initializeAlpineStores() {
  document.addEventListener('alpine:init', () => {
    Alpine.store('localAssistantApp', localAssistantAppStore);
  });
}


initializeAlpineStores();
